import { render } from "./HiFeeds.vue?vue&type=template&id=f5b812fe"
import script from "./HiFeeds.vue?vue&type=script&lang=js"
export * from "./HiFeeds.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__